import { useEffect } from "react";
import { useLocation } from "react-router";
import CollectHero from "../components/simcollect/CollectHero";
import CollectRail from "../components/simcollect/CollectRail";
import CollectStory from "../components/simcollect/CollectStory";
import CollectOps from "../components/simcollect/CollectOps";
import CollectSystem from "../components/simcollect/CollectSystem";
import CollectClose from "../components/simcollect/CollectClose";

function SimCollectPage() {
  const { hash } = useLocation();

  useEffect(() => {
    const id = hash.replace("#", "");
    if (!id) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 160);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <CollectHero />
      <CollectRail />
      <CollectStory />
      <CollectOps />
      <CollectSystem />
      <CollectClose />
    </>
  );
}

export default SimCollectPage;
